/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".mat-radio-label[_ngcontent-%COMP%]{font-weight:300!important}  .mat-radio-label-content{font-weight:300!important;width:98%;white-space:normal!important;word-wrap:break-word}.mat-checkbox-layout[_ngcontent-%COMP%]{white-space:normal!important}"];
export { styles as styles };
